import withIcon from './NewIcon';
// @ts-ignore
import IconLinkedin from './icon/l/linkedin.svg';

export default withIcon(IconLinkedin);
